module.exports = __webpack_public_path__ + "img/34.6672a774.png";